const theme = {
  // Brand
  primary: "#0047FF",
  secondary: "blue",
  // Shade
  shade: {
    0: "#16181A",
    10: "#3C4044",
    20: "#61676E",
    30: "#828A93",
    40: "#B6BECB",
    50: "#B6BECB",
    60: "#B6BECB",
    70: "#DBE1EB",
    80: "#E9EDF5",
    90: "#F5F7FB",
    100: "#FFFFFF",
  },
  // Max Widths & Breakpoint
  maxWidth: "1200px",
  maxWidthImage: "840px",
  maxWidthText: "720px",
  gutter: "24px",
  breakpoints: {
    xs: "400px",
    sm: "600px",
    md: "900px",
    lg: "1200px",
    xl: "1600px",
  },
  // Other
  radius: {
    default: "4px",
  },
  opacity: {
    default: 0.4,
  },
  technical: {
    defaultColor: "#EEEEEE",
  },
}

export default theme
